import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
const OrganizationalSchema: React.FC = () => {
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!isMounted) return null;

	const schemaOrgJSONLD = {
		"@context": "https://schema.org",
		"@type": "Corporation",
		name: "Genemod",
		alternateName: "Genemod, Inc.",
		url: "https://genemod.net/",
		logo: "https://genemod.net/static/53cc325a0017e519803c391c45ff1125/caa5a/Logo.webp",
		sameAs: [
			"https://twitter.com/genemod",
			"https://www.linkedin.com/company/genemod/",
		],
	};

	return (
		<Helmet>
			<script type="application/ld+json">
				{JSON.stringify(schemaOrgJSONLD)}
			</script>
		</Helmet>
	);
};

export default OrganizationalSchema;
